import { stringObjectDTO } from './dto'
import { ElLoading, ElMessage, ElMessageBox, MessageBoxData } from 'element-plus'
import store from '@/store'

const PROMOTION_MESSAGE = '大促高峰时段暂不可用（09:00-10:30、15:00-18:00），其余时间正常开放。'

const PROMOTION_CONFIG = {
  june18: {
    ranges: [
      { start: '05-31', end: '06-05' },
      { start: '06-15', end: '06-20' }
    ],
    peakHours: [
      { start: 9, end: 10.5 },
      { start: 15, end: 18 }
    ]
  },
  double11: {
    ranges: [
      { start: '10-31', end: '11-01' },
      { start: '11-10', end: '11-13' }
    ],
    peakHours: [
      { start: 9, end: 10.5 },
      { start: 15, end: 18 }
    ]
  }
}

/**
 * 时间格式化
 */
export function dateFormat(fmt: string, date: Date): string {
  let ret
  const opt: stringObjectDTO = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (const k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length === 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
    }
  }
  return fmt
}

/**
 * 阻塞等待
 */
export function wait(timeout = 1000): Promise<undefined> {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout)
  })
}

/**
 * 节流
 */
function Shake() {
  let timer: any = -1
  return function (obj: () => undefined, millisecond = 300) {
    clearTimeout(timer)
    timer = setTimeout(obj, millisecond)
  }
}

export const shake = Shake()

// 确认窗
export function confirm(title: string, desc: string): Promise<MessageBoxData> {
  return ElMessageBox.confirm(desc, title, {
    confirmButtonText: '确定',
    cancelButtonText: '取消'
  })
}

// 输入窗
export function prompt(title: string, desc: string): Promise<MessageBoxData> {
  return ElMessageBox.prompt(desc, title, {
    confirmButtonText: '确定',
    cancelButtonText: '取消'
  })
}

export function isInPromotionPeakTime(): boolean {
  const now = new Date()
  const monthDay = `${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`

  for (const promotion of Object.values(PROMOTION_CONFIG)) {
    const isInDateRange = promotion.ranges.some((range) => monthDay >= range.start && monthDay <= range.end)

    if (!isInDateRange) continue

    const hour = now.getHours() + now.getMinutes() / 60
    const isInPeakHours = promotion.peakHours.some((peak) => hour >= peak.start && hour < peak.end)

    if (isInPeakHours) {
      return true
    }
  }

  return false
}

export async function checkPromotionTimeRestriction(): Promise<true> {
  if (!isInPromotionPeakTime()) {
    return Promise.resolve(true)
  }

  await ElMessageBox.alert(PROMOTION_MESSAGE, '温馨提示', {
    confirmButtonText: '确定'
  })

  return Promise.reject(new Error('PROMOTION_PEAK_TIME_RESTRICTED'))
}

export function windowOpen(data = {}) {
  window.open(
    window.location.pathname +
    '?tip' + location.hash
  )
  const channel = new BroadcastChannel('new_tab_staffBillDetail')
  const timer = setInterval(() => {
    channel.postMessage(JSON.stringify(data))
    console.log('postMessage')
  }, 50)
  channel.onmessage = e => {
    if (e.data === 'staffBillDetail_close') {
      clearInterval(timer)
      channel.close()
    }
  }
}

export function closewin(): void {
  setTimeout(() => {
    if (navigator.userAgent.indexOf('Firefox') !== -1 || navigator.userAgent.indexOf('Chrome') !== -1) {
      window.location.href = 'about:blank'
      window.close()
    } else {
      window.opener = null
      window.open('', '_self')
      window.close()
    }
  }, 5000)
}

// 身份证转年龄
export function getCardAge(identityCard: string) {
  const len = (identityCard + '').length
  if (len === 0) {
    return 0
  } else {
    if (len !== 15 && len !== 18) {
      // 身份证号码只能为15位或18位其它不合法
      return 0
    }
  }
  let strBirthday = ''
  if (len === 18) {
    // 处理18位的身份证号码从号码中得到生日和性别代码
    strBirthday = identityCard.substr(6, 4) + '/' + identityCard.substr(10, 2) + '/' + identityCard.substr(12, 2)
  }
  if (len === 15) {
    strBirthday = '19' + identityCard.substr(6, 2) + '/' + identityCard.substr(8, 2) + '/' + identityCard.substr(10, 2)
  }
  console.log(strBirthday, 'strBirthday')
  // 时间字符串里，必须是“/”
  const birthDate = new Date(strBirthday)
  console.log(birthDate, 'birthDate')
  const nowDateTime = new Date()
  let age = nowDateTime.getFullYear() - birthDate.getFullYear()
  // 再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() === birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

// 过滤身份证号 脱敏
export function filterIdCard(cardId: string) {
  return cardId ? cardId.replace(/(\d{6})\d{8}(\d{4}|(\d{3}(X|x)))/, '$1****$2') : ''
}

export interface FormTestingErroeDto {
  richText: {
    text: string
  }
}

export interface FormTestingDto {
  userName: string | FormTestingErroeDto[]
  idCardNo: string | FormTestingErroeDto[]
  serveCompanyName: null
  joinType: number
}

// 表格校验
export function formTesting(name: string | FormTestingErroeDto[], idCode: string | FormTestingErroeDto[]) {
  console.log(name, '校验名称')
  console.log(idCode, 'code名称')
  try {
    let text = ''
    let code = ''
    if (typeof name === 'object' || typeof idCode === 'object') {
      if (typeof name === 'object' && typeof idCode === 'string') {
        ; (name as any).richText.forEach((item: { text: string }) => {
          text = text += item.text
        })
        code = idCode as string
      }
      if (typeof idCode === 'object' && typeof name === 'string') {
        console.log((idCode as any).richText, 'idCode');
        ; (idCode as any).richText.forEach((item: { text: string }) => {
          code = code += item.text
        })
        text = name as string
      }
      if (typeof idCode === 'object' && typeof name === 'object') {
        ; (idCode as any).richText.forEach((item: { text: string }) => {
          code = code += item.text
        })
          ; (name as any).richText.forEach((item: { text: string }) => {
            text = text += item.text
          })
      }
      // console.log((item.getCell(1).value as any).richText, 'item.getCell(1).value')
      // (item.getCell(1).value as any).richText
      return {
        name: text,
        code: code
      }
    }
    return {
      name: '',
      code: ''
    }
  } catch (error) {
    console.log(error, 'error')
    return false
  }
}

export function urlTobase64(url: any) {
  return new Promise((resolve) => {
    const file = url.target.files[0]
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      resolve(reader.result)
    }
  })
}

// axios 请求 oss存储链接 转换成二进制后使用a标签下载
export function downLoadFile(res: any, type: number, time: any, remark: any) {
  console.log(res, 'resres')
  const typeArr = ['发薪单列表', '发薪明细', '对账单', '工资单', '领薪记录', '个人领薪记录', '归档管理', '合同列表', '批量投保明细', '日保列表', '充值记录', '下载中心', '安心保员工名单', '日保在保人员名单', '安心保在保人员名单', '人员维度子弹回单', '安心保充值记录', '员工列表']
  const secondary = {
    pay: '发薪充值记录',
    insurance: '日日保充值记录',
    sign: '电子签充值记录',
    period: '安心保充值记录'
  } as any
  console.log(remark, 'remarkremarkremark')
  const headers = res.headers
  const contentType = headers['Content-Type']
  const contentDisposition = headers['Content-Disposition']
  const blob = new Blob([res.data], { type: contentType })
  console.log(blob, 'blobblob')
  console.log('contentDisposition', contentDisposition)
  // 下载后文件名
  // const fileName = contentDisposition ? decodeURI(res.headers['Content-Disposition'].split(';')[1].split('=')[1]) : new Date().getTime() + (res.request.responseURL.includes('.xlsx') ? '.xlsx' : '.zip')
  // res.headers['Content-Disposition'].split(';')[1].split('=')[1]) : new Date().getTime() + (res.request.responseURL.includes('.xlsx') ? '.xlsx' : '.zip'
  let file_name = '.' + res.request.responseURL.match(/\.([^\.]+)$/)[1]
  const fileName = contentDisposition ? decodeURI(res.headers['Content-Disposition'].split(';')[1].split('=')[1]) : (type - 1 === 10 ? secondary[`${remark}`] : typeArr[type - 1]) + '_' + dateFormat('YYYY-mm-dd HH:MM:SS', new Date(time)) + file_name
  console.log(type - 1, typeArr[type - 1])
  console.log(fileName, '文件名字111')
  const downloadElement = document.createElement('a')
  const href = window.URL.createObjectURL(blob) // 创建下载的链接
  downloadElement.href = href
  downloadElement.download = fileName
  document.body.appendChild(downloadElement)
  downloadElement.click() // 点击下载
  document.body.removeChild(downloadElement) // 下载完成移除元素
  window.URL.revokeObjectURL(href) // 释放掉blob对象
}

export function downLoadBlob(res: Blob, title: string) {
  let url = window.URL.createObjectURL(new Blob([res], { type: 'application/vnd.ms-excel' }))
  let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', `${title}.xls`) // 对文件进行命名
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link) // 下载完成移除元素
  window.URL.revokeObjectURL(url) // 释放掉blob对象
}

export function downloadUrl(url: string, title: string) {
  let link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', `${title}.xls`) // 对文件进行命名
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link) // 下载完成移除元素
}

export async function downloadUrlInCurrent({ windowMessage, requestFileUrl }) {
  windowOpen(windowMessage)
  document.title = '正在下载中...'
  const loading = await ElLoading.service({
    fullscreen: true,
    text: '正在下载中，您可以在新界面继续操作'
  })
  window.location.href = await requestFileUrl()
  await ElMessage.success('导出成功！')
  await loading.close()
  closewin()
}

/**
 * wxUuid 唯一码
 */
export function wxUuid() {
  let s: any = []
  let hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  const uuid = s.join('')
  return uuid
}

export function isWeixin() {
  return navigator.userAgent.toLowerCase().indexOf('wechat') > -1
}

export function filterName(name: string) {
  if (name) {
    const len = name.length
    let others = ''
    for (let i = 0; i < len - 1; i++) {
      others += '*'
    }
    return name.charAt(0) + others
  }
  return ''
}

export function filterCompanyName(name: string) {
  if (name) {
    let len = name.length - 6
    if (len > 6) len = 6
    let others = ''
    for (let i = 0; i < len; i++) {
      others += '*'
    }
    return name.replace(/^(.{2}).+(.{4})$/, `$1${others}$2`)
  }
  return ''
}

export function filterProjectName(name: string) {
  if (name) {
    if (name.length > 3) {
      let len = name.length - 2
      if (len > 6) len = 6
      let others = ''
      for (let i = 0; i < len; i++) {
        others += '*'
      }
      return name.replace(/^(.{1}).+(.{1})$/, `$1${others}$2`)
    } else {
      return filterName(name)
    }
  }
  return ''
}

/**
 * 确定数组中的 中文值
 * @param {*} cellValue
 * @param {*} list
 * @param {*} textField
 * @param {*} valueField
 * @returns
 */
export const formatter = (
  cellValue: string,
  list: {
    label: string
    value: number
  }[],
  config?: {
    valueKey: string
  }
) => {
  if (Array.isArray(list)) {
    const item = list.find((_) => _[config?.valueKey || 'label'] === cellValue)
    return item ? item.label : cellValue
  } else if (Object.keys(list).length) {
    return list[cellValue] || cellValue
  }
  return cellValue
}

/**
 * 通过url下载文件并对下载的文件更名
 * @param {*} url
 * @param {*} filename
 */
export const downloadFileAndChangeName = (url: any, filename: any) => {
  function getBlob(url: string | URL) {
    return new Promise((resolve) => {
      const XML = new XMLHttpRequest()
      XML.open('GET', url as any, true)
      XML.responseType = 'blob'
      XML.onload = () => {
        if (XML.status === 200) {
          resolve(XML.response)
        }
      }
      XML.send()
    })
  }

  // 下载文件
  function saveAs(blob: any, filename: string) {
    const elelink = document.createElement('a')
    elelink.style.display = 'none'
    elelink.download = filename
    elelink.href = window.URL.createObjectURL(blob)
    document.body.appendChild(elelink)
    elelink.click()
    document.body.removeChild(elelink)
  }

  // 调用以上方法进行下载
  getBlob(url).then((blob) => {
    saveAs(blob, filename)
  })
}

export function downloadBlobFile(blobObject: Blob) {
  console.log(123, store.state.blobFileName)
  const fileName = store.state.blobFileName || '文件'
  const blob = new Blob([blobObject], {
    type: blobObject.type
  })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  a.click()
  window.URL.revokeObjectURL(url)
}

/**
 * 检查是否在扣费任务时间段内（23:55:00 - 23:59:59）
 * 如果在该时间段内，显示提示并拒绝操作
 * @returns Promise<boolean> 如果不在限制时间段内返回 true，否则 reject
 */
export function checkDeductionTaskTime(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    const now = new Date()
    const hours = now.getHours()
    const minutes = now.getMinutes()
    const seconds = now.getSeconds()

    // 判断是否在 23:55:00 到 23:59:59 之间
    if (hours === 23 && minutes >= 55) {
      confirm('温馨提示', '为保障扣费任务顺畅执行，每晚 23:55:00- 23:59:59期间将暂停使用该功能，感谢您的耐心等待！')
        .then(() => {
          reject(new Error('当前时间段不允许新增案件'))
        })
        .catch(() => {
          reject(new Error('当前时间段不允许新增案件'))
        })
    } else {
      resolve(true)
    }
  })
}

export default {
  prompt,
  confirm,
  filterName,
  formatter,
  filterCompanyName,
  downloadBlobFile,
  checkDeductionTaskTime
}
